var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"procard_wrap"},[_c('div',{staticClass:"procard_content"},[_c('div',{staticClass:"content_left"},[_c('div',{staticClass:"left_tit"},[_vm._v(_vm._s(_vm.$t('nav.redcPlus.workflow.description')))])]),_c('div',{staticClass:"content_right"},[_c('img',{staticClass:"responsive-img",attrs:{"src":_vm.procardImg,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }